import * as React from "react";

import { Label, LabelProps, SemanticCOLORS } from "../semantic-ui";
import { Color, Army } from "./GameState";

type ArmyConfig = {
  piece: string;
  name: string;
};

const ARMY_CONFIG: { [K in string]: ArmyConfig } = {
  classic: { piece: "k", name: "Classic" },
  nemesis: { piece: "p", name: "Nemesis" },
  empowered: { piece: "r", name: "Empowered" },
  reaper: { piece: "q", name: "Reaper" },
  two_kings: { piece: "k", name: "Two Kings" },
  animals: { piece: "n", name: "Animals" },
};

type Props = {
  labelColor?: SemanticCOLORS;
  color: Color;
  army: Army;
} & Omit<LabelProps, "labelColor" | "color" | "army">;

const ArmyLabel = ({ labelColor, color, army, ...rest }: Props) => {
  const config = ARMY_CONFIG[army];
  return (
    <Label color={labelColor} image {...rest}>
      <img
        src={`/images/piece_${config.piece}${
          color === "white" ? "w" : "b"
        }.png`}
        alt=""
        style={{ background: "#a5c663" }}
      />
      {config.name}
    </Label>
  );
};

ArmyLabel.defaultProps = {
  labelColor: "grey",
  color: "white",
};

export default ArmyLabel;
